import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface ColaboradorPayload {
  cedula: number;
  capacitacion: number;
  evaluacion_competencia: number;
  sufrio_siniestros: number;
  tipo: number;
  estado_pago: number;
  medio_transporte: number;
  rol_desplazamiento: number;
  vehiculo_frecuente: number;
  numero_paz: string;
  fecha_ultima_revision: string;
  estado: number;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

@Injectable({
  providedIn: "root",
})
export class ColaboradoresService {
  private apiUrl = `${environment.apiUrl}/api/colaboradores`;

  constructor(private http: HttpClient) {}

  createColaborador(payload: ColaboradorPayload): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload);
  }

  getAllColaboradores(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getColaboradorById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  getColaboradoresByCedula(cedula: number | string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/cedula/${cedula}`);
  }

  updateColaborador(id: number, payload: Partial<ColaboradorPayload>): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload);
  }

  deleteColaborador(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
